<template>
    <v-container fluid class="pa-4">
        <v-card>
            <v-card-title class="text-h6">
                <v-icon left color="primary">mdi-file-sign</v-icon>
                Contratti del dipendente
                <v-spacer></v-spacer>
                <v-btn color="primary" small @click="openNew">
                    <v-icon left small>mdi-plus</v-icon>
                    Nuovo contratto
                </v-btn>
                <v-btn icon class="ml-2" @click="load" :loading="loading">
                    <v-icon>mdi-refresh</v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text>
                <v-alert v-if="activeContract" type="success" dense text>
                    <strong>Contratto attivo:</strong>
                    {{ contractTypeText(activeContract.type) }}
                    <span v-if="activeContract.ccnl_code">— CCNL {{ activeContract.ccnl_code }}</span>
                    <span v-if="activeContract.level">/ liv. {{ activeContract.level }}</span>
                    dal {{ formatDate(activeContract.start_date) }}
                    <span v-if="activeContract.end_date"> al {{ formatDate(activeContract.end_date) }}</span>
                    <span v-if="activeContract.gross_annual_salary"> · RAL {{ formatCurrency(activeContract.gross_annual_salary) }}</span>
                    <span v-if="activeContract.working_hours_per_week"> · {{ activeContract.working_hours_per_week }}h/sett</span>
                    <span v-if="activeContract.shift_template_name"> · turno <strong>{{ activeContract.shift_template_name }}</strong></span>
                </v-alert>
                <v-alert v-else type="warning" dense text>
                    Nessun contratto attivo per questo dipendente.
                </v-alert>
            </v-card-text>

            <v-data-table
                :headers="headers"
                :items="contracts"
                :loading="loading"
                disable-pagination
                hide-default-footer
                dense>
                <template v-slot:item.type="{ item }">
                    <v-chip x-small :color="contractTypeColor(item.type)" text-color="white">{{ contractTypeText(item.type) }}</v-chip>
                </template>
                <template v-slot:item.start_date="{ item }">{{ formatDate(item.start_date) }}</template>
                <template v-slot:item.end_date="{ item }">{{ formatDate(item.end_date) }}</template>
                <template v-slot:item.gross_annual_salary="{ item }">{{ formatCurrency(item.gross_annual_salary) }}</template>
                <template v-slot:item.status="{ item }">
                    <v-chip x-small :color="statusColor(item.status)" text-color="white">{{ statusText(item.status) }}</v-chip>
                </template>
                <template v-slot:item.actions="{ item }">
                    <v-btn icon small :to="'/hrcontracts/' + item.id + '/edit'" title="Modifica"><v-icon small>mdi-pencil</v-icon></v-btn>
                    <v-btn v-if="item.status === 'active'" icon small color="error" @click="terminate(item)" title="Risolvi"><v-icon small>mdi-stop-circle</v-icon></v-btn>
                </template>
                <template v-slot:no-data>
                    <div class="pa-4 text-center text-caption">Nessun contratto.</div>
                </template>
            </v-data-table>
        </v-card>
    </v-container>
</template>

<script>
import { localDateStr } from '@/components/utilities/hrDates'
    export default {
        name: 'hr-employee-contracts',
        props: { id: Number },

        data() {
            return {
                contracts: [],
                loading: false,
                headers: [
                    { text: 'Tipo', value: 'type' },
                    { text: 'CCNL', value: 'ccnl_code' },
                    { text: 'Livello', value: 'level' },
                    { text: 'Inizio', value: 'start_date' },
                    { text: 'Fine', value: 'end_date' },
                    { text: 'RAL', value: 'gross_annual_salary' },
                    { text: 'Stato', value: 'status' },
                    { text: '', value: 'actions', sortable: false, align: 'end' },
                ],
            }
        },

        computed: {
            activeContract() {
                return this.contracts.find(c => c.status === 'active') || null
            },
        },

        methods: {
            load() {
                this.loading = true
                this.axios.get(`hremployees/${this.id}/contracts`).then(r => {
                    this.contracts = r.data.data || []
                    this.loading = false
                }, () => { this.loading = false })
            },
            openNew() {
                this.$router.push({
                    name: 'hrcontracts-create',
                    params: { defaultInput: { employee_id: this.id, status: 'active' }, redirect: { name: 'hremployees-contracts', params: { id: this.id } } },
                })
            },
            terminate(item) {
                if (!confirm('Risolvere il contratto?')) return
                this.axios.post(`hrcontracts/${item.id}/terminate`, { terminated_at: localDateStr() }).then(() => this.load())
            },
            contractTypeText(t) {
                return {
                    permanent: 'Tempo indeterminato',
                    fixed_term: 'Tempo determinato',
                    apprenticeship: 'Apprendistato',
                    internship: 'Stage / Tirocinio',
                    freelance: 'Collaborazione',
                }[t] || t
            },
            contractTypeColor(t) {
                return {
                    permanent: 'green',
                    fixed_term: 'orange',
                    apprenticeship: 'blue',
                    internship: 'purple',
                    freelance: 'teal',
                }[t] || 'grey'
            },
            statusText(s) {
                return { active: 'Attivo', expired: 'Scaduto', terminated: 'Risolto' }[s] || s
            },
            statusColor(s) {
                return { active: 'green', expired: 'orange', terminated: 'grey' }[s] || 'grey'
            },
            formatDate(d) { return d ? new Date(d).toLocaleDateString('it-IT') : '—' },
            formatCurrency(n) {
                if (n === null || n === undefined) return '—'
                return new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(n)
            },
        },

        created() {
            this.$store.commit('endProgress')
            this.load()
        },
    }
</script>
